import { render, staticRenderFns } from "./LottiePlayer.vue?vue&type=template&id=0449c827&"
import script from "./LottiePlayer.vue?vue&type=script&lang=js&"
export * from "./LottiePlayer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports